import validators from '@utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.sport, 'sport'));
    Object.assign(errors, validators.required(values.tournament_category, 'tournament_category'));
    Object.assign(errors, validators.required(values.competitor, 'competitor'));

    Object.assign(errors, validators.required(values.spiideo_team_uuid, 'spiideo_team_uuid'));
    Object.assign(errors, validators.required(values.sportradar_srt_url, 'sportradar_srt_url'));
    Object.assign(errors, validators.required(values.ligr_srt_url, 'ligr_srt_url'));

    if (values.spiideo_team_uuid) {
        Object.assign(errors, validators.maxLength(
            {value: values.spiideo_team_uuid, maxLength: 36},
            'spiideo_team_uuid'
        ));

        if (!errors.spiideo_team_uuid) {
            Object.assign(errors, validators.uuid(values.spiideo_team_uuid, 'spiideo_team_uuid'));
        }
    }

    if (values.sportradar_srt_url) {
        Object.assign(errors, validators.maxLength(
            {value: values.sportradar_srt_url, maxLength: 500},
            'sportradar_srt_url'
        ));
        Object.assign(errors, validators.srtUrl(values.sportradar_srt_url, 'sportradar_srt_url'));
    }

    if (values.ligr_srt_url) {
        Object.assign(errors, validators.maxLength(
            {value: values.ligr_srt_url, maxLength: 500},
            'ligr_srt_url'
        ));
        Object.assign(errors, validators.srtUrl(values.ligr_srt_url, 'ligr_srt_url'));
    }

    return errors;
};

export default validate;
